import { render, staticRenderFns } from "./co2-calculator-side-action.vue?vue&type=template&id=197e880a"
import script from "./co2-calculator-side-action.ts?vue&type=script&lang=js&external"
export * from "./co2-calculator-side-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports